// Core
import { select, put, take } from 'redux-saga/effects';

// Instruments
import { geoActions } from 'bus/geo/actions';

function selectCountry (countryId) {
    return select(({ geo }) => geo.get('countries').find(({ id }) => id === String(countryId)));
}

export function* selectCountryWorker (id) {
    let country = yield selectCountry(id);

    if (country) {
        return country;
    }

    yield put(geoActions.getCountries());
    yield take(geoActions.getCountriesSuccess);

    country = yield selectCountry(id);

    return country;
}
